"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var ThemeContext = react_1.default.createContext(false);
function ThemeProvider(_a) {
    var isTrainingOrg = _a.isTrainingOrg, children = _a.children;
    return react_1.default.createElement(ThemeContext.Provider, { value: isTrainingOrg }, children);
}
exports.default = ThemeProvider;
ThemeProvider.propTypes = {
    isTrainingOrg: prop_types_1.default.bool,
    children: prop_types_1.default.node,
};
function useTheme() {
    var context = react_1.default.useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
exports.useTheme = useTheme;
//# sourceMappingURL=ThemeProvider.js.map